import { useEffect } from "react";
import { ImageReadyState } from "../../input/TipTap/pendingImages";
import { useUploadStatusPoll } from "../../input/TipTap/useUploadStatusPoll";

export const ImageStatusProbe = ({
  textDocumentId,
  uploadId,
  onState,
}: {
  textDocumentId: string;
  uploadId: string;
  onState: (uploadId: string, state: ImageReadyState) => void;
}) => {
  const state = useUploadStatusPoll({ textDocumentId, uploadId, skip: false });
  useEffect(() => {
    onState(uploadId, state);
  }, [uploadId, state, onState]);
  return null;
};
